import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

interface TagsProps {
  tags?: string[];
  className?: string;
  variant?: "default" | "rose" | "bleuMarine" | "jaune" | "rouge" | "bleuCiel";
}

const variants = cva(
  "px-3 py-1 rounded-full text-sm transition-colors",
  {
    variants: {
      variant: {
        default: "bg-gray-100 text-gray-700 hover:bg-gray-200",
        rose: "bg-rose text-white hover:bg-rose-200",
        bleuMarine: "bg-bleu-marine text-white hover:bg-bleu-marine-200",
        jaune: "bg-yellow text-white hover:bg-yellow-200",
        rouge: "bg-red text-white hover:bg-red-200",
        bleuCiel: "bg-bleu-ciel text-white hover:bg-bleu-ciel-200",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export const Tags: React.FC<TagsProps> = ({ tags, className = '', variant }) => {
  if (!tags || tags.length === 0) return null;

  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {tags.map((tag, index) => (
        <span 
          key={index} 
          className={cn(variants({ variant }))}
        >
          #{tag}
        </span>
      ))}
    </div>
  );
};

export default Tags;
